export default "__VITE_ASSET__DhYAkcCt__"